import angular from 'angular';
import { NsjRoutingType } from '../../core/nsj-core';
import { LoadParams } from '../../shared/models/loadparams.model';
import {
    IMudancasTrabalhadoresTipo,
    IMudancasTrabalhadoresSalvarEscalaParam,
    IMudancasTrabalhadoresExcluirEscalaParam,
    IMudancasTrabalhadoresListarSemPaginacaoParam,
} from './models/mudancas-trabalhadores.model';

export class MeurhMudancasTrabalhadoresService {

    static $inject = ['$http', 'nsjRouting', '$rootScope', '$q'];

    public loadParams: LoadParams = new LoadParams();
    public loading_deferred: angular.IDeferred<unknown> = null;

    constructor(
        public $http: angular.IHttpService,
        public nsjRouting: NsjRoutingType,
        public $rootScope: angular.IRootScopeService,
        public $q: angular.IQService
    ) {
    }

    salvarEscala(entity: IMudancasTrabalhadoresSalvarEscalaParam, tipo: IMudancasTrabalhadoresTipo) {
        this.loading_deferred = this.$q.defer();
        entity['$$__submitting'] = true;

        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.nsjRouting.generate('meurh_mudancastrabalhadores_escala', {}, true),
                data: angular.copy(entity),
                timeout: this.loading_deferred.promise
            })
            .then((response) => {
                this.$rootScope.$broadcast('mudancastrabalhadores_escala_submitted', response, tipo);
                resolve(response.data);
            })
            .catch((error) => {
                this.$rootScope.$broadcast('mudancastrabalhadores_escala_submit_error', error, tipo);
                reject(error);
            }).finally(() => {
                entity['$$__submitting'] = false;
            });
        });
    }

    excluirEscala(entity: IMudancasTrabalhadoresExcluirEscalaParam, tipo: IMudancasTrabalhadoresTipo) {
        this.loading_deferred = this.$q.defer();
        entity['$$__submitting'] = true;

        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.nsjRouting.generate('meurh_mudancastrabalhadores_exclusao_escala', {}, true),
                data: angular.copy(entity),
                timeout: this.loading_deferred.promise
            })
            .then((response) => {
                this.$rootScope.$broadcast('mudancastrabalhadores_exclusao_escala_submitted', response, tipo);
                resolve(response.data);
            })
            .catch((error) => {
                this.$rootScope.$broadcast('mudancastrabalhadores_exclusao_escala_submit_error', error, tipo);
                reject(error);
            }).finally(() => {
                entity['$$__submitting'] = false;
            });
        });
    }

    salvarEmLote(entity: any[], tipo: IMudancasTrabalhadoresTipo) {
        this.loading_deferred = this.$q.defer();
        entity['$$__submitting'] = true;

        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.nsjRouting.generate('meurh_mudancastrabalhadores_inserir_mudancas_lote', {}, true),
                data: angular.copy(entity),
                timeout: this.loading_deferred.promise
            })
            .then((response: any) => {
                response.dataLength = entity.length;
                this.$rootScope.$broadcast('mudancastrabalhadores_lote_submitted', response, tipo);
                resolve(response.data);
            })
            .catch((error) => {
                this.$rootScope.$broadcast('mudancastrabalhadores_lote_submit_error', error, tipo);
                reject(error);
            }).finally(() => {
                entity['$$__submitting'] = false;
            });
        });
    }

    excluirEmLote(entity: Partial<any>[], tipo: IMudancasTrabalhadoresTipo) {
        this.loading_deferred = this.$q.defer();
        entity['$$__submitting'] = true;

        return this.$q((resolve, reject) => {
            this.$http({
                method: 'DELETE',
                url: this.nsjRouting.generate('meurh_mudancastrabalhadores_exclusao_em_lote', {}, true),
                data: angular.copy(entity),
                timeout: this.loading_deferred.promise
            })
            .then((response: any) => {
                response.dataLength = entity.length;
                this.$rootScope.$broadcast('mudancastrabalhadores_lote_deleted', response, tipo);
                resolve(response.data);
            })
            .catch((error) => {
                this.$rootScope.$broadcast('mudancastrabalhadores_lote_delete_error', error, tipo);
                reject(error);
            }).finally(() => {
                entity['$$__submitting'] = false;
            });
        });
    }

    editar(entity: any, tipo: IMudancasTrabalhadoresTipo) {
        this.loading_deferred = this.$q.defer();
        entity['$$__submitting'] = true;

        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.nsjRouting.generate('meurh_mudancastrabalhadores_substituir_mudanca', {}, true),
                data: angular.copy(entity),
                timeout: this.loading_deferred.promise
            })
            .then((response: any) => {
                response.dataLength = 1;
                this.$rootScope.$broadcast('mudancastrabalhadores_lote_edited', response, tipo);
                resolve(response.data);
            })
            .catch((error) => {
                this.$rootScope.$broadcast('mudancastrabalhadores_lote_edit_error', error, tipo);
                reject(error);
            }).finally(() => {
                entity['$$__submitting'] = false;
            });
        });
    }

    listarSemPaginacao(params: IMudancasTrabalhadoresListarSemPaginacaoParam) {
        this.loading_deferred = this.$q.defer();
        this.loadParams.busy = true;

        const urlParams = {
            estabelecimento: '',
            ...params
        };

        return this.$q((resolve, reject) => {
           this.$http
                .get(this.nsjRouting.generate(
                    'meurh_mudancastrabalhadores_indexsempaginacao', urlParams, true),
                    { timeout: this.loading_deferred.promise }
                )
                .then((response) => {
                    this.$rootScope.$broadcast('mudancastrabalhadores_sempaginacao_loaded', response.data, urlParams.tipo);
                    this.loadParams.busy = false;
                    resolve(response.data);
                })
                .catch((error) => {
                    this.loadParams.busy = false;
                    reject(error);
                });
        });
    }
}

angular.module('main').service('MeurhMudancasTrabalhadoresService', MeurhMudancasTrabalhadoresService);
